var _defs, _g, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoExpanded(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 638.74 134.42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill-rule:evenodd;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Exhibify_Panel-05"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-14"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1",
    className: "cls-1",
    points: "0 1.64 0 94.93 59.25 94.93 59.25 75.77 20.42 75.77 20.42 56.73 54.84 56.73 54.84 38.7 20.42 38.7 20.42 20.93 59.25 20.93 59.25 1.64 0 1.64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-2",
    className: "cls-1",
    d: "m68.32,94.93l21.43-30.51-22.44-32.53h22.94c3.91,5.8,7.44,11.98,11.6,19.16l10.84-19.16h22.19l-22.06,32.15,21.3,30.89h-22.82c-2.27-3.53-6.55-10.72-10.84-18.16l-10.46,18.16h-21.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-4",
    className: "cls-1",
    d: "m269.42,62.76c0-9.96-6.93-15.76-15.76-15.76s-15.89,5.8-15.89,15.76,7.06,15.76,15.89,15.76,15.76-5.8,15.76-15.76m19.54,1.01c-.13,21.05-13.87,32.52-31.51,32.52-10.84,0-17.4-4.66-20.42-8.45l-1.01,6.81h-17.77V-.39h19.16v38.07c4.54-5.55,12.61-8.19,20.17-8.19,17.4,0,31.52,11.72,31.39,34.29"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-7",
    className: "cls-1",
    d: "m297.49,94.93h19.54V31.9h-19.54v63.03Zm-1.26-83.96c0-6.18,4.92-10.97,11.09-10.97s10.97,4.79,10.97,10.97-4.92,11.09-10.97,11.09-11.09-4.92-11.09-11.09h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-9",
    className: "cls-1",
    d: "m204.84,56.1v38.95h-19.41v-34.29c0-12.23-8.07-13.11-11.09-13.11-3.53,0-12.61.88-12.61,12.86v34.54h-19.42V0h19.54v36.56c3.66-4.03,9.96-6.55,16.77-6.55,17.78,0,26.22,10.46,26.22,26.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-10",
    className: "cls-1",
    d: "m184.04,10.97c0-6.18,4.92-10.97,11.09-10.97s10.97,4.79,10.97,10.97-4.92,11.09-10.97,11.09-11.09-4.92-11.09-11.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-11",
    className: "cls-1",
    d: "m362.22,31.89h-6.23v-5.04c0-6.43,2.27-11.47,15-8.95V.63c-3.03-.5-6.05-.76-8.7-.76-16.01,0-25.97,8.19-25.97,26.98v5.04h-8.45v16.14h8.45l.13,46.9h19.54v-46.9h12.48l-6.24-16.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-12",
    className: "cls-1",
    d: "m424.06,31.89l-14.88,43.62-15.76-43.62h-21.37l7.73,19.98,19.43,49.99c-3.78,9.96-13.74,8.19-18.66,4.54l-5.04,16.39c10.84,4.92,32.52,7.56,41.48-16.39l27.99-74.5h-20.93Z"
  })))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m546.69,2.46l-35.6,93.88h-11.73L463.37,2.46h12.13l29.73,78.49,29.73-78.49h11.73Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m600.62,56.56l18.78,39.77h-12.65l-17.47-38.07h-26.08v38.07h-11.21V2.46h35.86c19.95,0,31.55,10.43,31.55,27.77,0,13.43-7.04,23.08-18.78,26.34Zm6.91-26.21c0-11.08-7.04-17.73-19.69-17.73h-24.64v35.46h24.77c12.91,0,19.56-6.91,19.56-17.73Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoExpanded);
export default __webpack_public_path__ + "static/media/logo-expanded.7287cb62e1c502e69f5af43f95394320.svg";
export { ForwardRef as ReactComponent };